import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import axios from 'axios';
import { userService } from '../services/userServices';

function ProfilePage() {
  const [profile, setProfile] = useState({
    name: "",
    mobile: "",
    email: "",
    dateOfBirth: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('idToken');
      if (!token) {
        navigate('/login');
        return;
      }

      const data = await userService.getProfile();
      if (data) {
        setProfile({
          name: data.name || "",
          mobile: data.phoneNumber || "",
          email: data.email || "",
          dateOfBirth: data.dateOfBirth ? data.dateOfBirth.split('T')[0] : "",
          profilePicture: data.profilePicture || "",
        });
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const handleInputChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value
    });
  };

  const handleUpdateProfile = async () => {
    try {
      const token = localStorage.getItem('idToken');
      if (!token) {
        navigate('/login');
        return;
      }

      await userService.updateProfile({
        name: profile.name,
        email: profile.email,
        dateOfBirth: profile.dateOfBirth,
      });
      setIsEditing(false);
      alert('Profile updated successfully!');
    } catch (error) {
      console.error('Error updating profile:', error);
      if (error.response?.status === 500) {
        alert('Server error. Please try again later.');
      } else {
        alert('Failed to update profile. Please check your input and try again.');
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('idToken');
    navigate('/login');
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="container" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", paddingTop: "20px" }}>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <button
                  onClick={handleBackClick}
                  className="btn btn-link text-decoration-none"
                  style={{ color: "rgb(51, 185, 119)" }}
                >
                  ← Back
                </button>
                <h2 className="card-title text-center mb-0">Profile</h2>
                <div style={{ width: "57px" }}></div>
              </div>

              <div className="text-center mb-4">
                <div className="position-relative d-inline-block">
                  
                 
                  <input
                    type="file"
                    id="profile-picture"
                    className="d-none"
                    accept="image/*"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={profile.name}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Mobile Number</label>
                <input
                  type="tel"
                  className="form-control"
                  name="mobile"
                  value={profile.mobile}
                  disabled={true}
                  readOnly
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={profile.email}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
              </div>

              <div className="mb-4">
                <label className="form-label">Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  name="dateOfBirth"
                  value={profile.dateOfBirth}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
              </div>

              <div className="d-grid gap-2">
                {isEditing ? (
                  <>
                    <button
                      className="btn rounded-pill"
                      style={{ backgroundColor: "rgb(51, 185, 119)", color: "white" }}
                      onClick={handleUpdateProfile}
                    >
                      Save Changes
                    </button>
                    <button
                      className="btn btn-secondary rounded-pill"
                      onClick={() => {
                        setIsEditing(false);
                        fetchProfile(); // Reset to original values
                      }}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <button
                    className="btn rounded-pill"
                    style={{ backgroundColor: "rgb(51, 185, 119)", color: "white" }}
                    onClick={() => setIsEditing(true)}
                  >
                    Update Profile
                  </button>
                )}
                <button 
                  onClick={handleLogout} 
                  className="btn bg-danger text-light rounded-pill border mt-2"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;